import { GET_LEVELPATH_API } from '../utils/api';

export const LOAD_SUBLEVEL1_REQUEST = '@SUBLEVEL/LOAD_SUBLEVEL1_REQUEST';
export type SUBLEVEL1_REQUEST = typeof LOAD_SUBLEVEL1_REQUEST;

export const LOAD_SUBLEVEL2_REQUEST = '@SUBLEVEL/LOAD_SUBLEVEL2_REQUEST';
export type SUBLEVEL2_REQUEST = typeof LOAD_SUBLEVEL2_REQUEST;

export const RESET_SUBLEVEL1_REQUEST = '@SUBLEVEL/RESET_SUBLEVEL1_REQUEST';
export type RESET_SUBLEVEL1 = typeof RESET_SUBLEVEL1_REQUEST;

export const RESET_SUBLEVEL2_REQUEST = '@SUBLEVEL/RESET_SUBLEVEL2_REQUEST';
export type RESET_SUBLEVEL2 = typeof RESET_SUBLEVEL2_REQUEST;

export interface zeroSublevel1 {
    type: RESET_SUBLEVEL1;
    payload: {
        sublevels1: null,
    }
}

export function resetSublevel1(): zeroSublevel1 {
    return {
        type: RESET_SUBLEVEL1_REQUEST,
        payload: {
            sublevels1: null
        }
    }
}

export interface zeroSublevel2 {
    type: RESET_SUBLEVEL2;
    payload: {
        sublevels2: null,
    }
}

export function resetSublevel2(): zeroSublevel2 {
    return {
        type: RESET_SUBLEVEL2_REQUEST,
        payload: {
            sublevels2: null
        }
    }
}

export interface LoadSUBLEVEL1 {
    type: SUBLEVEL1_REQUEST;
    payload: {
        sublevels1: null,
    }
}

export async function loadSUBLEVEL1(body: any): Promise<LoadSUBLEVEL1> {
    try {
        const response = await GET_LEVELPATH_API(body);
        return {
            type: LOAD_SUBLEVEL1_REQUEST,
            payload: {
                sublevels1: response.data
            }
        };
    } catch (error) {
        return {
            type: LOAD_SUBLEVEL1_REQUEST,
            payload: {
                sublevels1: Object(error)
            }
        }
    }
}

export interface LoadSUBLEVEL2 {
    type: SUBLEVEL2_REQUEST;
    payload: {
        sublevels2: null,
    }
}

export async function loadSUBLEVEL2(body: any): Promise<LoadSUBLEVEL2> {
    try {
        if (body) {
            const response = await GET_LEVELPATH_API(body);
            return {
                type: LOAD_SUBLEVEL2_REQUEST,
                payload: {
                    sublevels2: response.data
                }
            };
        } else {
            return {
                type: LOAD_SUBLEVEL2_REQUEST,
                payload: {
                    sublevels2: null
                }
            };
        }
    } catch (error) {
        return {
            type: LOAD_SUBLEVEL2_REQUEST,
            payload: {
                sublevels2: Object(error)
            }
        }
    }
}